import React from 'react'
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Screenshots from "../components/Screenshots";
import About from "../components/About";
import Download from "../components/Download";
import Footer from "../components/Footer";

const Home = () => {
  return (
        <>
          <Navbar />
          <Hero />
          <Features />
          <Screenshots />
          <About />
          <Download />
          <Footer />
        </>
  )
}

export default Home